import { Operation, OperationColors, OperationLabels } from "components/Car/types";
import Flex from "components/Flex";
import Text from "components/Text";

import { useClientTranslation } from "hooks/useClientTranslation";
import { CAR_PART_TRANSLATION_KEYS, CarPart } from "types/CarPart";

import { useStyles } from "./styles";

type PartOperationProps = {
  part: CarPart;
  operation: Operation;
  replacementPartCost?: string | null;
};

export const PartOperation = ({ part, operation, replacementPartCost }: PartOperationProps) => {
  const { classes } = useStyles();
  const { t } = useClientTranslation();

  return (
    <Flex
      as="li"
      direction="row"
      align="center"
      py={12}
      aria-label={t(CAR_PART_TRANSLATION_KEYS[part])}
      className={classes.operationRow}
    >
      <Text sizeVariant="md" style={{ flexBasis: "50%" }}>
        {t(CAR_PART_TRANSLATION_KEYS[part])}
      </Text>
      <div style={{ flexBasis: '25%' }}>
        <div className={classes.operation} style={{background: OperationColors[operation].accent}}>
          <Text sizeVariant="md" weight={500} style={{color: OperationColors[operation].textColor}}>
            {t(OperationLabels[operation])}
          </Text>
        </div>
      </div>
      {typeof replacementPartCost === 'string' && <div style={{textAlign: 'right', flexBasis: '25%'}} data-testid="replacementPartCost">
        {replacementPartCost}
      </div>}
    </Flex>
  );
};
